import { AsyncStatus, LocationAttr } from 'enums';
import { axiosAPI } from './API';
import { ILocation, ILocationsMap } from 'interfaces';

export interface ILocationAttrs {
    [attr: string]: string[],
}

// Singleton for interacting with locations
class _LocationsService {
    private attributesP: Promise<ILocationAttrs>;
    private attributesStatus = AsyncStatus.Initial;

    public locationsMap: ILocationsMap = {};

    public getAllLocations = (): Promise<ILocationsMap> => {
        return axiosAPI.get<ILocationsMap>("/allLocations")
            .then((resp) => {
                this.locationsMap = resp.data;
                return this.locationsMap;
            })
            .catch((err) => {
                console.error("Error getting all locations: ", err);
                throw err;
            });
    }

    public getAttributes(): Promise<ILocationAttrs> {
        // Load once, then return the cached results. The locations almost never change.
        if (!this.attributesP || this.attributesStatus === AsyncStatus.Error) {
            this.attributesStatus = AsyncStatus.Loading;
            this.attributesP = axiosAPI.get<ILocationAttrs>('/locationAttributes')
                .then((response) => {
                    this.attributesStatus = AsyncStatus.Success;
                    const attrs = response.data || {};

                    // Sort values case-insensitive
                    var collator = new Intl.Collator(undefined, {sensitivity: 'base'});

                    // Iterate our expected attributes
                    for (const attr of Object.values(LocationAttr)) {
                        // WARNING: The response won't have any properties if the server failed to load from the locations API.
                        if (!attrs[attr]) attrs[attr] = [];
                        attrs[attr].sort(collator.compare);
                    }

                    return attrs;
                });
            // Doing a separate catch to avoid stopping the error from going up the chain.
            this.attributesP.catch((err) => {
                this.attributesStatus = AsyncStatus.Error;
                console.error('Error getting location attributes: ', err);
            });
        }

        return this.attributesP;
    }
}

export const LocationsService = new _LocationsService();